import { PATH as ORIGIN } from '../const';

export const NAMESPACE = 'surcharges';
export const PATH = `${ORIGIN}/${NAMESPACE}`;
